﻿package com.mgacreative.hotelru.shared.ui.designsystem.di

import com.mgacreative.hotelru.core.network.SupabaseNetworkClient
import com.mgacreative.hotelru.core.tenant.TenantSession
import org.koin.dsl.module

fun getCommonAppModule() = module {
    single { TenantSession() }
    single { SupabaseNetworkClient() }
    single { get<SupabaseNetworkClient>().client }
}

